export const getReturnToBlogHomeTitle = ({
  isNews,
  isVoices,
  isCircleOfChairs,
  isPodcast
}: {
  isNews: boolean
  isVoices: boolean
  isCircleOfChairs: boolean
  isPodcast: boolean
}) => {
  switch (true) {
    case isNews:
      return 'Return to News Articles'
    case isVoices:
      return 'Return to Recovery Voices'
    case isCircleOfChairs:
      return 'Return to Circle of Chairs'
    case isPodcast:
      return 'Return to Podcasts'
    default:
      return 'Return to Resource Library'
  }
}
